export default __webpack_public_path__ + "static/media/noteapp.0f987f7c.png";